<template>
  <div class="d-flex pb-2 justify-content-center WebsiteContents">
    <ContentSidebarLinks
      :tabs="tabs"
      :opened="opened"
      
      v-model="content"
    >
      <template #icon-pages>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
        </svg>
      </template>
      <template #icon-blocks>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
        </svg>
      </template>
      <template #icon-menus>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </template>

      <transition name="fade-trans">
        <Tab
          :active="opened"
          
          @click.native="opened = !opened"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" />
          </svg>
        </Tab>
      </transition>
    </ContentSidebarLinks>
    <div class="tab-content">
      
      <transition name="fade-trans" mode="out-in">
        <WebsiteMenus v-if="content === 'menus'" key="webiste"
          :website-uid="websiteUid"
          :removeCardStyle="true"
        />
        <BlocksCrud v-else-if="content === 'blocks'" key="blocks"
          :opened="opened"
        />
        <PagesCrud v-else key="asht"
          :opened="opened"
        />
      </transition>
      
    </div>
  </div>
</template>

<script>

import ContentSidebarLinks from "./ContentSidebarLinks/ContentSidebarLinks.vue"
import Tab from "./ContentSidebarLinks/Tab.vue"

export default {
  props: {
    websiteUid: String,
  },
  components: {
    WebsiteMenus: () => import(
      /* webpackPrefetch: true */
      "../../WebsiteMenus/WebsiteMenus.vue"
    ),
    PagesCrud: () => import(
      /* webpackPrefetch: true */
      "./PagesCrud.vue"
    ),
    BlocksCrud: () => import(
      /* webpackPrefetch: true */
      "./BlocksCrud.vue"
    ),

    Tab,
    ContentSidebarLinks,
  },
  data() {
    return {
      content: "",
      opened: true,
      tabs: [
        {
          name: "Pages",
          id: "pages",
        },
        {
          name: "Blocks",
          id: "blocks",
        },
        {
          name: "Menus",
          id: "menus",
        },
      ],
    }
  },
}

</script>

<style scoped>

.WebsiteContents {
  position: absolute;
  height: 100%;
  min-width: 768px;
  overflow: auto;
}

@media (min-width: 768px) {
  .WebsiteContents {
    width: 100%;
  }
}

.tab-content {
  flex-basis: 100%;
}

tab-content > div {
  min-height: 600px;
}

</style>
